export enum environment {
    DEVELOPMENT,
    STAGING,
    PRODUCTION,
    LOCALHOST
}

// function to get the environment value based on env
const getAppEnvironment = () => {
    //setting build_environment variable into aws amplify console for different environments
    switch (process.env.REACT_APP_BUILD_ENVIRONMENT) {
        case "DEV":
            return environment.DEVELOPMENT;
        case "UAT":
            return environment.STAGING;
        case "PROD":
            return environment.PRODUCTION;
        case "LOCALHOST":
            return environment.LOCALHOST;
        default:
            return environment.DEVELOPMENT;
    }
}

export const APP_ENV: environment = getAppEnvironment() // function to set the environment based environment

export const getBaseUrl = (): string => {
    switch (APP_ENV) {
        case environment.DEVELOPMENT:
            return 'https://cemdev.mmtcpamp.com/pvc'
        case environment.STAGING:
            return 'https://cemuat.mmtcpamp.com/pvc'
        case environment.PRODUCTION:
            return 'https://cem.mmtcpamp.com/pvc'
        case environment.LOCALHOST:
            return 'http://localhost:3001/pvc'
        default:
            return 'https://cemdev.mmtcpamp.com/pvc'
    }
}

export const SERVER_URL = getBaseUrl();

export const cookieUrl = (): string => {
    switch (APP_ENV) {
        case environment.DEVELOPMENT:
            return '.mmtcpamp.com'
        case environment.STAGING:
            return '.mmtcpamp.com'
        case environment.PRODUCTION:
            return '.mmtcpamp.com'
        case environment.LOCALHOST:
            return 'localhost'
    }
}
